import { Box } from 'components'
import { getSpacing } from 'utils'

export const SectionContainer = (...[{ children, ...other }]: Parameters<typeof Box>) => (
  <Box padding={getSpacing('m')} backgroundColor={'BG_ELEVATED'} borderRadius="14px" {...other}>
    {children}
  </Box>
)
